import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './adminCertificate.css';

const AdminCertificate = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 👈 detect query param
  const [searchTerm, setSearchTerm] = useState('');
  const [certificates, setCertificates] = useState([]);

  // Fetch all certificates from your local backend
  const fetchCertificates = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_API_URL+'/api/certificates');
      const data = await res.json();
      setCertificates(data.reverse()); // show most recent first
    } catch (error) {
      console.error('Error fetching certificates:', error);
    }
  };

  useEffect(() => {
    fetchCertificates();
  }, [location.search]); // 👈 re-fetch if refresh param is present

  const handleAddClick = () => {
    navigate('/admin/add-certificate');
  };

  // Delete certificate using _id from MongoDB
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this certificate?')) {
      try {
        await fetch(process.env.REACT_APP_API_URL+`/api/certificates/${id}`, {
          method: 'DELETE',
        });
        fetchCertificates(); // Refresh list after deletion
      } catch (error) {
        console.error('Error deleting certificate:', error);
      }
    }
  };

  const filteredCertificates = certificates
    .filter(cert => cert.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      if (a.name.toLowerCase().startsWith(searchTerm.toLowerCase())) return -1;
      return 0;
    });

  return (
    <div className="certificate-container">
      <header className="certificate-header">
        <img src="/flytutor_logo.png" alt="FlyTutor Logo" className="logo" />
        <h1 className="panel-title">Admin Panel</h1>
      </header>

      <div className="certificate-content">
        <div className="admin-name">
          <span className="label">Admin Name :</span> <span className="admin">Sanjay</span>
        </div>

        <div className="search-section">
          <input
            type="text"
            placeholder="Search..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="search-icon">🔍</button>
          <span className="certificate-tag">Certificates</span>
        </div>

        <ul className="certification-list">
          {filteredCertificates.map((item) => (
            <li key={item._id} className="certification-item">
              <span>{item.name}</span>
              <div className="button-group">
                <button className="update-btn" onClick={() => navigate(`/admin/edit/${item._id}`)}>🔁 update</button>
                <button className="delete-btns" onClick={() => handleDelete(item._id)}>🗑️</button>
              </div>
            </li>
          ))}
        </ul>

        <button className="add-certification-btn" onClick={handleAddClick}>
          ➕
        </button>
      </div>
    </div>
  );
};

export default AdminCertificate;


